export default __webpack_public_path__ + "static/media/Logo_Node.31c0e97d.png";